import EquipmentNameFormatter from './EquipmentNameFormatter'

export default EquipmentNameFormatter
